import { createMuiTheme } from "@material-ui/core";

import styles from "./index.css";

// eslint-disable-next-line no-unused-vars
const s = styles;

export const CONTENT_MAX_WIDTH = 1500;
export const SIDEBAR_WIDTH = 240;

export const theme = createMuiTheme({
  typography: {
    fontSize: 16,
  },
  palette: {
    primary: {
      main: "#de1f26",
    },
  },
});
